import SidebarMobile from "./Sidebar"

export default SidebarMobile



// WEBPACK FOOTER //
// ./src/components/SidebarMobile/index.jsx